import {
  Anchor,
  Award,
  BarChart3,
  BookA,
  BookOpen,
  Calculator,
  CloudSun,
  Compass,
  CreditCard,
  FileText,
  FolderLock,
  HelpCircle,
  LifeBuoy,
  Lock,
  MapPinned,
  Megaphone,
  Navigation,
  Newspaper,

  Settings,
  Shield,
  ShieldCheck,
  Ship,
  Users,
  Waves,
  Wrench,
} from "lucide-react";
import { getLocalizedPath } from "@/lib/i18nRoutes";

export const MENU_GROUPS = [
  { key: "home", labelKey: "captainDashboard" },
  { key: "planTrip", labelKey: "planMyTrip" },
  { key: "navigate", labelKey: "navigateGroup" },
  { key: "learn", labelKey: "learnGroup" },
  { key: "community", labelKey: "communityGroup" },
  { key: "myBoat", labelKey: "myBoat" },
  { key: "profile", labelKey: "profile" },
  { key: "admin", labelKey: "adminPanel" },
];

export const MAIN_MENU = [
  { key: "dailyBriefing", labelKey: "dailyBriefing", icon: "Newspaper", group: "home", zone: "public", tier: "free", publicHref: "/daily-briefing", appHref: "/daily-briefing" },
  { key: "home", labelKey: "home", icon: "BarChart3", group: "home", zone: "public", tier: "free", publicHref: "/", appHref: "/dashboard" },
  { key: "dashboard", labelKey: "dashboard", icon: "BarChart3", group: "home", zone: "app", tier: "free", appHref: "/dashboard" },

  { key: "weather", labelKey: "weather", icon: "CloudSun", group: "planTrip", zone: "public", tier: "free", publicHref: "/weather", appHref: "/weather" },
  { key: "marinas", labelKey: "marinas", icon: "Anchor", group: "planTrip", zone: "public", tier: "free", publicHref: "/marinas", appHref: "/marinas" },
  { key: "tools", labelKey: "tools", icon: "Calculator", group: "planTrip", zone: "public", tier: "free", publicHref: "/sailing-calculators", appHref: "/sailing-calculators" },
  { key: "trips", labelKey: "trips", icon: "Navigation", group: "planTrip", zone: "app", tier: "premium", publicHref: "/premium", appHref: "/trips" },

  { key: "navigation", labelKey: "navigation", icon: "Compass", group: "navigate", zone: "public", tier: "free", publicHref: "/navigation", appHref: "/navigation" },
  { key: "safety", labelKey: "safety", icon: "LifeBuoy", group: "navigate", zone: "public", tier: "free", publicHref: "/safety", appHref: "/safety" },
  { key: "aisCollisionCenter", labelKey: "aisCollisionCenter", icon: "ShieldCheck", group: "navigate", zone: "premium", tier: "premium", publicHref: "/premium", appHref: "/ais-collision-center" },
  { key: "offline", labelKey: "offline", icon: "Compass", group: "navigate", zone: "app", tier: "premium", publicHref: "/premium", appHref: "/offline" },

  { key: "learningCenter", labelKey: "learningCenter", icon: "BookOpen", group: "learn", zone: "public", tier: "free", publicHref: "/learning-center", appHref: "/learning-center" },
  { key: "glossary", labelKey: "glossary", icon: "BookA", group: "learn", zone: "public", tier: "free", publicHref: "/glossary", appHref: "/glossary" },
  { key: "regulations", labelKey: "regulations", icon: "Shield", group: "learn", zone: "public", tier: "free", publicHref: "/regulations", appHref: "/regulations" },
  { key: "wire", labelKey: "wire", icon: "Newspaper", group: "learn", zone: "public", tier: "free", publicHref: "/wire", appHref: "/wire" },

  { key: "community", labelKey: "community", icon: "Users", group: "community", zone: "public", tier: "free", publicHref: "/community", appHref: "/community" },
  { key: "affiliate", labelKey: "affiliate", icon: "Award", group: "community", zone: "app", tier: "free", publicHref: "/affiliate", appHref: "/affiliate" },
  { key: "advertise", labelKey: "advertise", icon: "Megaphone", group: "community", zone: "public", tier: "free", publicHref: "/advertise", appHref: "/advertise" },

  { key: "boats", labelKey: "boats", icon: "Ship", group: "myBoat", zone: "app", tier: "premium", publicHref: "/premium", appHref: "/boats" },
  { key: "maintenance", labelKey: "maintenance", icon: "Wrench", group: "myBoat", zone: "app", tier: "premium", publicHref: "/premium", appHref: "/maintenance" },
  { key: "boatDocumentVault", labelKey: "boatDocumentVault", icon: "FolderLock", group: "myBoat", zone: "premium", tier: "premium", publicHref: "/premium", appHref: "/boat-document-vault" },
  { key: "voyageHistory", labelKey: "voyageHistory", icon: "Navigation", group: "myBoat", zone: "app", tier: "premium", publicHref: "/premium", appHref: "/voyage-history" },
  { key: "metrics", labelKey: "metrics", icon: "BarChart3", group: "myBoat", zone: "app", tier: "premium", publicHref: "/premium", appHref: "/metrics" },

  { key: "settings", labelKey: "settings", icon: "Settings", group: "profile", zone: "public", tier: "free", publicHref: "/settings", appHref: "/settings" },
  { key: "servicesOnboarding", labelKey: "servicesOnboarding", icon: "FileText", group: "profile", zone: "app", tier: "free", publicHref: "/premium", appHref: "/onboarding" },
  { key: "billing", labelKey: "billing", icon: "CreditCard", group: "profile", zone: "app", tier: "free", publicHref: "/premium", appHref: "/billing" },
  { key: "help", labelKey: "help", icon: "HelpCircle", group: "profile", zone: "app", tier: "free", publicHref: "/premium", appHref: "/help" },

  { key: "adminPanel", labelKey: "adminPanel", icon: "Shield", group: "admin", zone: "admin", tier: "admin", publicHref: "/admin", appHref: "/admin" },
];

const ICONS = {
  Anchor,
  Award,
  BarChart3,
  BookA,
  BookOpen,
  Calculator,
  CloudSun,
  Compass,
  CreditCard,
  FileText,
  FolderLock,
  HelpCircle,
  LifeBuoy,
  Lock,
  MapPinned,
  Megaphone,
  Navigation,
  Newspaper,

  Settings,
  Shield,
  ShieldCheck,
  Ship,
  Users,
  Waves,
  Wrench,
};

const LOCALIZED_ROUTE_KEYS = {
  "/": "home",
  "/daily-briefing": "dailyBriefing",
  "/weather": "weather",
  "/marinas": "marinas",
  "/routes": "routes",
  "/navigation": "navigation",
  "/safety": "safety",
  "/learning-center": "learningCenter",
  "/glossary": "glossary",
  "/regulations": "regulations",
  "/wire": "wire",
  "/community": "community",
  "/advertise": "advertise",
  "/affiliate": "affiliate",
  "/settings": "settings",
  "/sailing-calculators": "tools",
  "/premium": "premium",
  "/dashboard": "dashboard",
  "/boats": "boats",
  "/trips": "premium",
  "/voyage-history": "premium",
  "/metrics": "premium",
  "/offline": "offline",
  "/onboarding": "premium",
  "/billing": "premium",
  "/help": "premium",
  "/ais-collision-center": "aisCollisionCenter",
  "/boat-document-vault": "boatDocumentVault",
};

export function getMenuIcon(iconName) {
  return ICONS[iconName] || Compass;
}

export function resolveMenuHref(item, mode = "public", lang = "en") {
  const href = mode === "app" ? item.appHref : item.publicHref;
  if (!href) return null;
  if (mode === "app" && item.key === "home") return "/dashboard";
  if (mode === "app" && item.key === "maintenance") return `/${lang}/maintenance`;
  if (mode === "app" && item.key === "trips") return `/${lang}/trips`;
  // Private app/admin/premium destinations are intentionally unlocalized in App.jsx.
  if (mode === "app" && item.zone !== "public") return href;
  if (href.startsWith("/admin")) return href;
  if (href === "/wire") return `/${lang}/wire`;

  const routeKey = LOCALIZED_ROUTE_KEYS[href];
  if (!routeKey) {
    if (mode === "app") return href;
    console.warn(`[mainMenu] Unable to resolve menu route for ${item.key}: ${href}`);
    return null;
  }

  const localizedHref = getLocalizedPath(routeKey, lang);
  if (localizedHref === `/${lang}` && href !== "/") {
    console.warn(`[mainMenu] Menu route resolved to home unexpectedly for ${item.key}: ${href}`);
    return null;
  }

  return localizedHref;
}

export function isItemAllowedForState(item, state, mode = "public") {
  if (!item) return false;
  if (mode === "public" && !item.publicHref) return false;
  if (mode === "app" && !item.appHref) return false;
  if (item.zone === "admin") return !!state?.isAdmin;
  if (item.zone === "app" && mode === "app" && !state?.isLoggedIn) return false;
  return true;
}

export function isPremiumItemGranted(item, state) {
  if (!item || item.tier !== "premium") return false;
  if (state?.isAdmin || state?.isPremium || state?.premiumAccessAll) return true;
  const grantedPages = state?.premiumPages || [];
  return grantedPages.includes(item.key) || grantedPages.includes(item.appHref?.replace(/^\//, ""));
}

export function isMenuItemLocked(item, state) {
  if (item.tier === "admin") return !state?.isAdmin;
  if (item.tier === "premium") return !isPremiumItemGranted(item, state);
  return false;
}